/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react'

import Box from '/components/Commons/Box'
import { jsx, Text } from 'theme-ui'

import styles from './styles'

const UpperFooterSection = ({ cmsContent }) => {
  return (
    <React.Fragment>
      {cmsContent && (
        <Box sx={styles.container}>
          <Box sx={styles.contentWrapper}>
            <Text sx={styles.title} as="p">
              {cmsContent?.firstSectionTitle}
            </Text>
            <ul>
              {cmsContent?.firstSectionContent?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <Text
              sx={{
                ...styles.title,
                marginBottom: '10px',
              }}
              as="p"
            >
              {cmsContent?.secondSectionTitle}
            </Text>
            <ul>
              {cmsContent?.secondSectionContent?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <Text sx={styles.thirdSectionTitle} as="p">
              {cmsContent?.thirdSectionTitle}
            </Text>
            <Text sx={styles.thirdSectionText} as="p">
              {cmsContent?.thirdSectionContent}
            </Text>
          </Box>
        </Box>
      )}
    </React.Fragment>
  )
}

export default UpperFooterSection
